<template lang="html">
  <span>
    <b-btn
      v-if="show.privacyState == 'world'"
      :href="link"
      :size="size"
      :variant="variant"
      class="ml-1"
    >
      Link <v-icon name="link" />
    </b-btn>
    <span :id="id" class="d-inline-block">
      <b-btn
        v-if="show.privacyState != 'world'"
        :href="link"
        :size="size"
        :variant="variant"
        :disabled="disableButton"
        :class="{ nopointer: disableButton }"
        class="ml-1"
      >
        Link <v-icon name="lock" />
      </b-btn>
    </span>
    <b-tooltip v-if="disableButton" ref="tooltip" :target="id">
      <v-icon name="exclamation-triangle" /> This show contains features which
      can only be exported to video. Privacy options are limited to private view
      only.
    </b-tooltip>
    <b-tooltip v-if="privateShow" ref="tooltip-private" :target="id">
      <v-icon name="exclamation-triangle" /> Only you can see this show.
    </b-tooltip>
    <b-tooltip v-if="privateLink" ref="tooltip-private-link" :target="id">
      <v-icon name="exclamation-triangle" /> Anyone with the private link can
      see this show.
    </b-tooltip>
    <b-tooltip v-if="passwordLink" ref="tooltip-private-link" :target="id">
      <v-icon name="exclamation-triangle" /> Anyone with the password can see
      this show.
    </b-tooltip>
  </span>
</template>

<script>
import { Show } from "@/models/showModel";
export default {
  name: "LinkButton",
  props: {
    show: {
      required: true,
      type: Object,
      default: () => {},
    },
    variant: {
      type: String,
      default: () => "secondary",
    },
  },
  data() {
    return {
      size: "md",
    };
  },
  computed: {
    id() {
      return (
        "tooltip-" +
        Math.random()
          .toString(36)
          .substring(2, 15)
      );
    },
    readOnlyShowModel() {
      if (this.show) {
        return new Show(this.show);
      }
      return {};
    },
    link() {
      return this.readOnlyShowModel.link;
    },
    isPublishable() {
      return this.readOnlyShowModel.isPublishable;
    },
    privateShow() {
      if (this.disableButton) {
        return false;
      }
      if (!this.show.privacyState) {
        return true;
      }
      return this.show.privacyState == "private";
    },
    privateLink() {
      if (this.disableButton) {
        return false;
      }
      return this.show.privacyState == "privateLink";
    },
    passwordLink() {
      if (this.disableButton) {
        return false;
      }
      return this.show.privacyState == "password";
    },
    disableButton() {
      // Disable if show can't be published (motion or video)
      if (!this.isPublishable) {
        return true;
      }
      // Never disable when this component is used from /shows listing.
      if (this.$route.name === "shows") {
        return false;
      }
      return this.$store.getters["show/displayInitialImporter"];
    },
  },
};
</script>

<style lang="css" scoped>
.nopointer {
  pointer-events: none;
}
</style>
